import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BlogCategory } from '../../../models/blog-post.model';
import { BlogListingModel } from '../../../models/blog-listing.model';

@Component({
  selector: 'mj-blog-category',
  templateUrl: './blog-category.component.html',
  styleUrls: ['./blog-category.component.scss'],
})
export class BlogCategoryComponent implements OnInit {
  @Input() categories: Array<BlogCategory>;
  @Input() blogListing: BlogListingModel;
  @Output() didSelectCategory = new EventEmitter<BlogCategory>();
  constructor() {}

  ngOnInit() {}

  onCategorySelected(category) {
    this.didSelectCategory.emit(category);
  }
}
